export default "__VITE_ASSET__DbAAvwtD__"